import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ICartItemForUpdate } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import cloneDeep from "lodash/cloneDeep";
export var buildUpdateCartProto = function(item, properties, includeTesterInfo) {
    var _item_customizations;
    return ICartItemForUpdate.build(_object_spread({
        token: item.token,
        brand_token: item.brand_token,
        product_token: item.product_token,
        product_option_token: item.product_option_token,
        quantity: item.quantity,
        customizations: (_item_customizations = item.customizations) !== null && _item_customizations !== void 0 ? _item_customizations : [],
        includes_tester: includeTesterInfo ? item.includes_tester : undefined,
        tester_price: includeTesterInfo && item.includes_tester ? item.tester_price : undefined
    }, properties));
};
export var createBrandCartForUpdate = function(brand_token, items, saved_for_later, requested_ship_date) {
    return {
        brand_token: brand_token,
        saved_for_later: saved_for_later,
        items: items !== null && items !== void 0 ? items : [],
        requested_ship_date: requested_ship_date,
        token: undefined
    };
};
export var generateBrandCartForUpdates = function(baseBrandCarts, items, requestShipDates) {
    var brandCarts = cloneDeep(baseBrandCarts);
    items.forEach(function(baseItem) {
        var item = cloneDeep(baseItem);
        var brandCart = brandCarts.find(function(brandCart) {
            return brandCart.brand_token === item.brand_token;
        });
        if (brandCart) {
            brandCart.items.push(item);
        } else {
            brandCarts.push(createBrandCartForUpdate(item.brand_token, [
                item
            ]));
        }
    });
    if (requestShipDates) {
        Object.keys(requestShipDates).forEach(function(brand_token) {
            var brandCart = brandCarts.find(function(brandCart) {
                return brandCart.brand_token === brand_token;
            });
            var requestShipDate = requestShipDates[brand_token];
            if (brandCart) {
                brandCart.requested_ship_date = requestShipDate;
            } else {
                brandCarts.push(createBrandCartForUpdate(brand_token, undefined, undefined, requestShipDate));
            }
        });
    }
    return brandCarts;
};
